import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AddTransactionComponent } from '../../../../modals/add-transaction/add-transaction.component';
import { Subject, Subscription } from 'rxjs';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { ActivatedRoute } from '@angular/router';
import { HcaBookingService } from '../../../../../shared/_services/hca-booking.service';
import { HcaMemberService } from '../../../../../shared/_services/hca-member.service';

@Component({
  selector: 'app-booking-transaction-history',
  templateUrl: './booking-transaction-history.component.html',
  styleUrls: ['./booking-transaction-history.component.scss']
})
export class BookingTransactionHistoryComponent implements OnInit {
  memberSubscription: Subscription;
  memberInfo: any;
  bookingId: number;
  transId: number;
  totalCount: number;
  p: number = 0;
  size: number = 10;
  transactionList: any[];
  memberId: string | number;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  destroySubscription$: Subject<boolean> = new Subject();

  constructor(
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private hcaBookingService: HcaBookingService,
    private hcaMemberService : HcaMemberService
  ) {
    this.modalService.onHide
    .takeUntil(this.unsubscribe)
    .subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action == "action1") {
          if (this.statusModal.content.srcObject.type == "member-edit") {
            if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
              let status = +this.statusModal.content.srcObject.status;
              this.updateTransactionStatus(this.statusModal.content.srcObject.id, status);
            } else {
              this.getTransactionHistory();
            }
          } else {
            this.getTransactionHistory();
          }
        }
      }
    })
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.bookingId = +params['id']; // (+) converts string 'id' to a number;
      this.transId = +params['transId'];
      this.getTransactionHistory();
    })
    this.memberId = this.hcaMemberService.getMemberId;
    this.memberInfo = this.hcaMemberService.getMemberInfo;
    this.getTransactionHistory();
    this.memberSubscription = this.hcaMemberService.memberData$
      .takeUntil(this.destroySubscription$)
      .subscribe((state: any) => {
        if (state) {
          this.memberInfo = state;
          if (this.memberInfo && this.memberInfo.manualPoints) {
            this.updateBadgeStatus(this.memberId, 'manualPoints');
          }
        }
      });
  }
  updateTransactionStatus(transactionId, statusId) {
    this.hcaMemberService.updateTransactionStatus(transactionId, statusId).subscribe(res => {
      this.getTransactionHistory();
    }, err => {
      console.error('Error while updating promotion status: ', err.message);
    });
  }

  updateBadgeStatus(memberId, type) {
    this.hcaMemberService.updateBadgeEvents(memberId, type).subscribe(res => {
      if (res.error == 0) {
        this.memberInfo = res.responseObj;
        this.hcaMemberService.setMember(this.memberInfo);
      }
    }, err => {
      console.error('Error while updating member issue status by Id: ', err.message);
    });
  }

  getTransactionHistory() {
    this.hcaBookingService.getTransactionHistory(this.transId).subscribe(res => {
      if (res.error == 0) {
        this.transactionList = res.responseObj ? res.responseObj : [];
        this.totalCount = res.responseObj && res.responseObj.totalRecords ? res.responseObj.totalRecords : 0;
      }
    }, err => {
      console.error('Error while getting transaction list with booking id: ', err.message);
    })
  }
  openStatusModal(id?, mode?, statusType?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = `Are you sure you want to ${statusType.toLowerCase()} this transaction?`
    let title = `${statusType} Transaction`;
    let action1 = `${statusType}`;
    let style = (mode == 0 || mode == 3 || mode == 4) ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'member-edit',
      title: title,
      message: message,
      status,
      id,
      action1: action1 == 'Cancel' ? 'Confirm' : action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }
  goBack() {
    window.history.back();
  }
  openModalAddTransaction() {
    this.statusModal = this.modalService.show(AddTransactionComponent, { class: 'add-transaction-modal' });
    if (this.memberId) {
      this.statusModal.content.memberId = this.memberId;
    }
  }


  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.destroySubscription$.next(true);
    this.destroySubscription$.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/bookings/booking-transaction-history/booking-transaction-history.component.ts